import { render, staticRenderFns } from "./allocated.vue?vue&type=template&id=2a4cc8ea&scoped=true&"
import script from "./allocated.vue?vue&type=script&lang=js&"
export * from "./allocated.vue?vue&type=script&lang=js&"
import style0 from "./allocated.vue?vue&type=style&index=0&id=2a4cc8ea&lang=scss&scoped=true&"
import style1 from "./allocated.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4cc8ea",
  null
  
)

export default component.exports